<template>
    <div
        v-tippy
        class="preset-thumbnail ml-1 cursor-pointer"
        :content="preset.label"
        :class="{
            disabled
        }"
        @click="handleClick"
    >
        <div class="thumbnail-container">
            <c-lazy>
                <img v-if="preset.thumbnail" :src="preset.thumbnail" :alt="preset.label" class="thumbnail-image" lazy />
                <img
                    v-else
                    :src="require('@/angular-app/images/placeholderCustomily.png')"
                    :alt="preset.label"
                    class="thumbnail-image"
                    lazy
                />
            </c-lazy>
        </div>

        <div class="preset-label">{{ preset.label }}</div>
    </div>
</template>

<script setup lang="ts">
import { MapStylePresetType } from '@/components/DesignStudio/MapStyleProperties/types';
import CLazy from '@/components/CLazy.vue';

interface Props {
    preset: MapStylePresetType;
    disabled?: boolean;
}

interface Emits {
    (event: 'select', preset: MapStylePresetType): void;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false
});

const emit = defineEmits<Emits>();

const handleClick = () => {
    if (props.disabled) return;
    emit('select', props.preset);
};
</script>

<style scoped lang="scss">
@import 'styles/utilities/functions';

.preset-thumbnail {
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 6px;

    &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.thumbnail-container {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;
    border: 1px solid get-color('gray-light');
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        border-color: get-color('purple');
    }
}

.thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
}

.preset-label {
    font-weight: 500;
    font-size: 11px;
    color: #333;
    margin-top: 6px;
    line-height: 1.2;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
